"use client";

import { useTranslations } from "next-intl";
import { Link } from "@/i18n/navigation";
import { routes } from "@/lib/routes";
import { useCookieConsent } from "@/lib/use-cookie-consent";
import { setCookieConsent } from "@/lib/cookie-consent";
import { Button } from "@/components/ui/button";
import { Container } from "@/components/layout/container";

/**
 * Visibile solo finché non c'è una scelta salvata (consent === null). La mappa
 * di Google in Contatti è a parte (click-to-load, non passa da qui): questo
 * banner riguarda solo Google Analytics, l'unico cookie di terze parti che
 * parte da solo senza un'azione esplicita della persona sulla pagina.
 */
export function CookieBanner() {
  const consent = useCookieConsent();
  const t = useTranslations("cookieConsent");

  if (consent !== null) return null;

  return (
    <div
      role="region"
      aria-label={t("label")}
      className="fixed inset-x-0 bottom-0 z-40 border-t border-pietra-light/50 bg-bianco-carta shadow-[0_-8px_24px_rgba(28,28,26,0.1)]"
    >
      <Container className="flex flex-col items-start gap-4 py-5 md:flex-row md:items-center md:justify-between">
        <p className="max-w-[62ch] text-sm leading-[1.6] text-inchiostro/90">
          {t("text")}{" "}
          <Link href={routes.cookie} className="border-b border-pietra-light hover:text-rosso-pozzo">
            {t("policyLink")}
          </Link>
        </p>
        <div className="flex shrink-0 gap-3">
          <Button type="button" variant="secondary" onClick={() => setCookieConsent("rejected")}>
            {t("reject")}
          </Button>
          <Button type="button" variant="primary" onClick={() => setCookieConsent("accepted")}>
            {t("accept")}
          </Button>
        </div>
      </Container>
    </div>
  );
}
